export var UrlValidatorErrors;
(function (UrlValidatorErrors) {
    UrlValidatorErrors["MAX_LENGTH_ERROR"] = "MAX_LENGTH_ERROR";
    UrlValidatorErrors["NO_SPACES_ERROR"] = "NO_SPACES_ERROR";
    UrlValidatorErrors["NO_EMPTY_SEGMENT_ERROR"] = "NO_EMPTY_SEGMENT_ERROR";
    UrlValidatorErrors["CONTAIN_MAIN_VARIABLE_ERROR"] = "CONTAIN_MAIN_VARIABLE_ERROR";
    UrlValidatorErrors["ONLY_ONE_VARIABLE_PER_SEGMENT_ERROR"] = "ONLY_ONE_VARIABLE_PER_SEGMENT_ERROR";
    UrlValidatorErrors["ONLY_UNIQUE_PUBLISHED_URL_ERROR"] = "ONLY_UNIQUE_PUBLISHED_URL_ERROR";
    UrlValidatorErrors["ONLY_UNIQUE_SAVED_URL_ERROR"] = "ONLY_UNIQUE_SAVED_URL_ERROR";
    UrlValidatorErrors["ONLY_UNIQUE_MAPPING_ERROR"] = "ONLY_UNIQUE_MAPPING_ERROR";
    UrlValidatorErrors["NO_INVALID_CHARACTERS_ERROR"] = "NO_INVALID_CHARACTERS_ERROR";
    UrlValidatorErrors["NO_STARTING_OR_ENDING_SLASH_ERROR"] = "NO_STARTING_OR_ENDING_SLASH_ERROR";
})(UrlValidatorErrors || (UrlValidatorErrors = {}));
//# sourceMappingURL=types.js.map